<template>
  <div class="bottom">
    <div class="btn">
      <van-button
        class="btnBox btnBoxCancel"
        round
        :plain="true"
        @click="reset"
      >
        {{ lang('取消') }}
      </van-button>
      <van-button class="btnBox" round :plain="true" @click="confirm">
        {{ lang('确定') }}
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import lang from '@/langs'
const emits = defineEmits(['reset', 'confirm'])
const reset = () => {
  emits('reset')
}
const confirm = () => {
  emits('confirm')
}
</script>

<style scoped lang="less">
.bottom {
  background: #fff;
  display: flex;
  flex-direction: column;
  .btn {
    height: 58px;
    width: 100%;
    display: flex;
    .btnBox {
      width: 100%;
      background: linear-gradient(
        90deg,
        rgba(250, 81, 15, 1),
        rgba(255, 0, 0, 1) 100%
      ); /* 从左到右的渐变 */
      color: #fff;
      font-size: 16px;
    }
    .btnBoxCancel {
      background: #fff; /* 从左到右的渐变 */
      color: rgba(60, 60, 60, 1);
      font-size: 14px;
      margin-right: 16px;
    }
    border-top-width: 1px;
    border-top-color: rgba(242, 242, 242, 1);
  }
}
</style>
